// extracted by mini-css-extract-plugin
var _1 = "EmailTableRowActivitiesMoreItem-moduleEmailTableRowActivitiesMoreItem__Buq4A MultiValuedListMoreItem-moduleMultiValuedListMoreItem__SSTEE";
export { _1 as "EmailTableRowActivitiesMoreItem" }
